module.exports = __webpack_public_path__ + "static/supreme-logo-2244ab51977150180d416a6b3b29dc0c.svg";